import { NavLink, useNavigate } from "react-router-dom";
import { P11, P11_LOGO } from "./p11shared";
import { useP11Lang } from "./p11lang";
import { SoundToggle } from "./p11fx";

// Deelnemers-shell: minimale navigatie + taalkeuze.
export default function P11Layout({ children }) {
  const nav = useNavigate();
  const { lang, toggle, tt } = useP11Lang();
  const links = [
    { to: "/project11/dashboard", label: tt("dashboard"), id: "dashboard" },
    { to: "/project11/sessions", label: tt("my_sessions"), id: "sessions" },
    { to: "/project11/record", label: tt("the_record"), id: "record" },
    { to: "/project11/profile", label: tt("my_profile"), id: "profile" },
  ];
  const logout = () => { localStorage.removeItem("p11_token"); nav("/project11/login", { replace: true }); };

  return (
    <div className="p11-root relative min-h-screen" data-testid="p11-layout">
      <header className="flex items-center justify-between px-5 md:px-10 py-5 border-b" style={{ borderColor: P11.border }}>
        <div className="flex items-center gap-3">
          <img src={P11_LOGO} alt="Project 11*" className="h-5 object-contain" />
          <span className="p11-label hidden sm:inline">JOH. BOXING</span>
        </div>
        <div className="flex items-center gap-4">
          <SoundToggle />
          <button onClick={toggle} className="p11-label hover:text-white transition-colors" data-testid="p11-lang-toggle">{lang === "nl" ? "EN" : "NL"}</button>
          <button onClick={logout} className="p11-label hover:text-white transition-colors" data-testid="p11-logout">{tt("logout")}</button>
        </div>
      </header>
      <nav className="flex gap-1 px-3 md:px-10 overflow-x-auto border-b" style={{ borderColor: P11.border }} data-testid="p11-nav">
        {links.map((l) => (
          <NavLink key={l.id} to={l.to} data-testid={`p11-nav-${l.id}`}
            className={({ isActive }) => `p11-label px-3 py-3.5 whitespace-nowrap border-b-2 transition-colors ${isActive ? "text-[#FFE44D] border-[#FFE44D]" : "text-[#858585] border-transparent hover:text-white"}`}>
            {l.label}
          </NavLink>
        ))}
      </nav>
      <main className="px-5 md:px-10 py-8 max-w-3xl mx-auto w-full">{children}</main>
    </div>
  );
}
